import NotificationSequence from '../state/notificationSequence';

export const createSequenceRequestPayload = (keyOrder, langCd) => (
    new NotificationSequence({
        keyOrder,
        langCd,
    })
);
